import React from 'react';
import { ICON_MAPPING, ICON_DESCRIPTIONS } from '../../constants/icons';
import '../../views/paquete-detalle/styles.css';

const DynamicIncludesRow = ({ paquetesIncluidos, className, fullWidth = false, ...props }) => {
  if (!paquetesIncluidos?.length) {
    return null;
  }

  const isStringArray = typeof paquetesIncluidos[0] === 'string';

  return (
    <div
      className={`internal-package__includes__row ${className ?? ''}`}
      style={{ maxWidth: fullWidth ? '360px' : 'max-content' }}
      {...props}
    >
      <div className="internal-package__includes__title" style={{ marginRight: '1rem' }}>
        Incluye:
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-around', flex: 1 }}>
        {paquetesIncluidos.map((included, index) => {
          let iconCode;
          let description;

          if (isStringArray) {
            iconCode = included;
            description = ICON_DESCRIPTIONS[included] || included;
          } else {
            iconCode = included.icon?.codigo;
            description =
              included.icon?.descripcion || ICON_DESCRIPTIONS[included.icon?.codigo] || '';
          }

          const IconComponent = ICON_MAPPING[iconCode];

          if (!IconComponent) {
            return null;
          }

          return (
            <div
              key={isStringArray ? index : included.id}
              className="internal-package__includes__item"
            >
              <IconComponent
                className="internal-package__includes__icon"
                style={iconCode === 'fa fa-plane' ? { transform: 'scaleX(-1)' } : {}}
              />
              {description && <span>{description}</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DynamicIncludesRow;
